export const CURRENT_CONFIG = {

  // license
  appId: '178775',
  appKey: '88dd16a0ef9d3a4f61b30df3b1b2bba',
  appLicense: 'PRTUZ/pwhN2YG+eD6cH/mxLbl3SwzeIg5NqQiAbjFVMI6rB6t6SCjSBeJzJlHJ1fFR0J0zce9UHiZQVCayL0x+XaAnmxVhMOR/eT9uzP4EBaNwX4kPzLXfhqL3GQKSdtf3Tfp9EQ3Baz6VEA0ZT+oJvEhoR5KKy0BVW/On8FMok=',

  // http
  baseURL: 'https://dji.airwingdrones.com/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'wss://dji.airwingdrones.com/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://95.111.247.208/airwing-live/', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  googleMapKey: 'AIzaSyAocwxdSxmzjog_aqNVCjdOwgJ3h_KT1RI',

}
